export default __webpack_public_path__ + "static/media/Letter O.f5df3035.mov";